import { render, staticRenderFns } from "./BookIcon.vue?vue&type=template&id=a95218f0"
import script from "./BookIcon.vue?vue&type=script&lang=ts"
export * from "./BookIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports